"use client";
import dynamic from "next/dynamic";
import React from "react";

const ParaphraserEditor = dynamic(
  () => import("@/components/tools/ParaphraserEditor/ParaphraserEditor"),
  { ssr: false },
);
const ParaphraserCoreSection = () => {
  return (
    <div className="my-4 rounded-[8px] bg-[#FFFFFF]">
      <ParaphraserEditor />
    </div>
  );
};
export default ParaphraserCoreSection;
